import { render, staticRenderFns } from "./TblDetailQRcode.vue?vue&type=template&id=5fd20053&scoped=true&"
import script from "./TblDetailQRcode.vue?vue&type=script&lang=js&"
export * from "./TblDetailQRcode.vue?vue&type=script&lang=js&"
import style0 from "./TblDetailQRcode.vue?vue&type=style&index=0&id=5fd20053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd20053",
  null
  
)

export default component.exports